export default "__VITE_ASSET__2f6b9548__"